import { Component, Inject, OnInit, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonsService } from '@core/service/commons.service';
import { LicenseService } from './license.service';
import { SettingsService } from '@delon/theme';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc';

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.css']
})
export class LicenseComponent extends LicenseService implements OnInit {

  //上传的文件
  files: File[] = [];

  //接受后端信息的实体类
  licenseInfo = {
    registCode:"",
    custom:"",
    timeEnd:"",
    modules:[]
  };

  //点击上传文件
  upload(){
    if (0 == this.files.length ){
      this.commons.showErrorMessage("licenseGrant.tips.noFile");
      return;
    }
    this.commons.showConfirm("licenseGrant.tips.uploadConfirm",()=>this.goUpload(),()=>this.uploadCensel());
  }

  //取消文件上传
  uploadCensel(){
  }

  //文件上传的具体操作
  goUpload(){
    this.changeLicense(this.files[0]).subscribe((data:any) => {
      if (data.code === 0){
        this.commons.showSuccessMessage("licenseGrant.tips.successUpload");
        this.licenseInfo = {
          registCode:"",
          custom:"",
          timeEnd:"",
          modules:[]
        };
        this.ngOnInit();
        this.files = [];
        this.router.navigate(["/passport/login"]);
      } else {
        this.files = [];
        this.commons.showErrorMessage("licenseGrant.tips.errorFile")
      }
    });
  }

  //文件上传时的钩子，每次选中文件后执行的方法
  beforeUpload= (file): boolean => {
    if(file != null && file.name != null && file.name != ""){
      let index = file.name.lastIndexOf(".");
      let suf = file.name.substring(index+1,file.name.length);
      if (suf != "key"){
        this.commons.showErrorMessage("licenseGrant.tips.error");
        return false;
      }
    }
    if (this.files.length == 0 ){
      this.files.push(file);
    }else{
      this.files.splice(0);
      this.files.push(file)
    }
    return false;
  };

  callMe(){
    this.commons.showInfoMessage("passport.login.call")
  }

  constructor(http: HttpClient,
              private commons:CommonsService,
              private router: Router
  ) {
    super(http)
  }

  ngOnInit() {
    this.get().subscribe(data =>{
      this.licenseInfo = data;
      if (this.licenseInfo['custom'] == "" || this.licenseInfo['custom'] == null){
        this.licenseInfo['custom'] = this.commons.translate("licenseGrant.tips.noGrant")
      }
      if (this.licenseInfo['timeEnd'] == "" || this.licenseInfo['timeEnd'] == null){
        this.licenseInfo['timeEnd'] = this.commons.translate("licenseGrant.tips.noTime")
      }
    })
  }

}
